import { Link } from "react-router-dom"

import "./LMSPortal.css"
import Footer from "../Footer/Footer"
import Navbar from "../Navbar/Navbar"
import {
  FaGraduationCap,
  FaLaptopCode,
  FaUniversity,
  FaExternalLinkAlt,
  FaGlobe
} from "react-icons/fa"



const LMSPortal = () => {

  const courses = {
    UG: [
      { id: "bcom-ca", name: "B.Com (Computer Applications)" },
      { id: "bsc-cs", name: "B.Sc Computer Science" },
      { id: "bsc-horticulture", name: "B.Sc Horticulture" }
    ],

    Engineering: [
      { id: "btech-ai", name: "B.Tech Artificial Intelligence" },
      { id: "btech-civil", name: "B.Tech Civil Engineering" },
      { id: "btech-cse", name: "B.Tech Computer Science & Engineering" },
      { id: "btech-ece", name: "B.Tech Electronics & Communication Engineering" },
      { id: "btech-mech", name: "B.Tech Mechanical Engineering" }
    ],

    PG: [
      { id: "msc-biotech", name: "M.Sc Biotechnology" },
      { id: "msc-botany", name: "M.Sc Botany" },
      { id: "mba", name: "M.B.A" },
      { id: "msc-chemistry", name: "M.Sc Chemistry" },
      { id: "mcom", name: "M.Com" },
      { id: "mca", name: "M.C.A" },
      { id: "msc-cs", name: "M.Sc Computer Science" },
      { id: "ma-english", name: "M.A English" },
      { id: "ma-economics", name: "M.A Economics" },
      { id: "msc-food", name: "M.Sc Food Science & Nutrition" },
      { id: "msc-maths", name: "M.Sc Mathematics" },
      { id: "msc-stats", name: "M.Sc OR & SQC (Statistics)" },
      { id: "msc-physics", name: "M.Sc Physics" },
      { id: "ma-telugu", name: "M.A Telugu" },
      { id: "msc-zoology", name: "M.Sc Zoology" }
    ]

  }
  const onlinePlatforms = [
  {
    name: "SWAYAM",
    description: "Government of India MOOCs platform",
    link: "https://swayam.gov.in"
  },
  {
    name: "NPTEL",
    description: "Engineering, Science & Management courses by IITs",
    link: "https://nptel.ac.in"
  },
  {
    name: "Coursera",
    description: "Global online courses from universities & companies",
    link: "https://www.coursera.org"
  },
  {
    name: "edX",
    description: "Online courses from top global universities",
    link: "https://www.edx.org"
  },
  {
    name: "UGC MOOCs",
    description: "UGC approved online learning resources",
    link: "https://ugcmoocs.inflibnet.ac.in"
  }
]


  const renderCards = list =>
    list.map(course => (
      <div key={course.id} className="lms-card">
        <h3 className="lms-course-title">{course.name}</h3>

        <Link to={`/lms/${course.id}`} className="lms-btn">
          View Course
        </Link>
      </div>
    ))

  return (
    <>
   <Navbar/>
    <section className="lms-section">
      <div className="lms-container">

        {/* HEADER */}
        <div className="lms-header">
          <FaUniversity className="lms-icon-main" />
          <h1>Learning Management System</h1>
          <p>
            Select your programme to access course materials, lecture videos,
            assignments and academic resources.
          </p>
        </div>

        {/* UG */}
        <div className="lms-block">
          <h2><FaGraduationCap /> Undergraduate Programmes</h2>
          <div className="lms-grid">
            {renderCards(courses.UG)}
          </div>
        </div>

        {/* ENGINEERING */}
        <div className="lms-block">
          <h2><FaLaptopCode /> Engineering Programmes</h2>
          <div className="lms-grid">
            {renderCards(courses.Engineering)}
          </div>
        </div>

        {/* PG */}
        <div className="lms-block">
          <h2><FaGraduationCap /> Postgraduate Programmes</h2>
          <div className="lms-grid">
            {renderCards(courses.PG)}
          </div>
        </div>

      </div>
      {/* ONLINE LEARNING PLATFORMS */}
<div className="lms-block">
  <h2 style={{textAlign:'center'}}><FaUniversity /> Online Learning Platforms</h2>

  {/* <p className="lms-platform-desc">
    Students are encouraged to use the following national and international
    online learning platforms for additional learning resources.
  </p> */}

  <div className="lms-grid">
    <a
      href="https://nptel.ac.in"
      target="_blank"
      rel="noopener noreferrer"
      className="lms-card"
    >
      <h3 className="lms-course-title">NPTEL</h3>
      <span className="lms-btn">Visit Platform</span>
    </a>

    <a
      href="https://swayam.gov.in"
      target="_blank"
      rel="noopener noreferrer"
      className="lms-card"
    >
      <h3 className="lms-course-title">SWAYAM</h3>
      <span className="lms-btn">Visit Platform</span>
    </a>

    <a
      href="https://www.coursera.org"
      target="_blank"
      rel="noopener noreferrer"
      className="lms-card"
    >
      <h3 className="lms-course-title">Coursera</h3>
      <span className="lms-btn">Visit Platform</span>
    </a>

    <a
      href="https://www.edx.org"
      target="_blank"
      rel="noopener noreferrer"
      className="lms-card"
    >
      <h3 className="lms-course-title">edX</h3>
      <span className="lms-btn">Visit Platform</span>
    </a>
  </div>
</div>

    </section>
    

    <Footer />
    </>
  )
}

export default LMSPortal
